const invertedMessages = {
  'External identities should be certified with an average of once in a quarter':
    'external.dashboard.recommendations.tooltip',
  'Average User Manager Certifications':
    'external.dashboard.recommendations.certified',
  'Uncertified Active Users': 'external.dashboard.recommendations.uncertified',
  'Since last 12 months': 'external.dashboard.recommendations.sinceTime',
};

export default invertedMessages;
